import { useRoute } from '#imports'
import { computed } from 'vue'

export function useOrderlinePublicIdFromRoute() {
  const route = useRoute()

  return computed(() => route.params.orderlinePublicId as string)
}
